export interface Option {
  label: string
  value?: any
}

interface Condition extends Option {
  type: string
}

export interface ConfigType {
  options?: Option[]
  conditions?: Condition[]
}

export default class InputTypeConfig {
  [propName: string]: any;
  radio: ConfigType = {
    options: [
      {
        label: 'Yes',
        value: 'Yes'
      }, {
        label: 'No',
        value: 'No'
      }
    ]
  }

  dropdown: ConfigType = {
    options: [
      {
        label: 'Yes',
        value: 'Yes'
      },
      {
        label: 'No',
        value: 'No'
      }
    ]
  }

  video: ConfigType = {
    conditions: [
      {
        label: 'Video URL',
        type: 'input',
        value: null
      },
      {
        label: 'Force Watching [%] of video',
        type: 'input',
        value: null
      },
      {
        label: 'Show Timeline',
        type: 'switch',
        value: null
      }
    ]
  }
}
